// extracted by mini-css-extract-plugin
module.exports = {"container":"Center_container__C2gkW","h_center":"Center_h_center__2wb85","v_center":"Center_v_center__2Dh91"};